<template lang="pug">
.monster-box
  .row(v-if='loading')
    .col-12.text-center
      h2 Loading...
  sprite-select(v-if='!loading')
  .row.has-monsters(v-if='!loading && favoriteMonster.name')
    main-sprite
    user-sprite-list
</template>

<style lang="scss" scoped>
  .monster-box {
    min-height: 540px;
  }

  h2 {
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: 3px;
    text-align: center;
    text-transform: uppercase;
    color: #6c6d69;
  }
</style>

<script>
import MainSprite from './MainSprite';
import SpriteSelect from './SpriteSelect';
import UserSpriteList from './UserSpriteList';

export default {
  name: 'MonsterBox',
  components: {
    MainSprite,
    SpriteSelect,
    UserSpriteList,
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    usersMonsters() {
      return this.$store.state.usersMonsters;
    },
    favoriteMonster() {
      return this.$store.state.favoriteMonster;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/monsters/MonsterBox.vue